<template>
	<Sprite/>
	<Header :page="page"/>
	<div style="display: none">
		<h1>Avocado | Avocado</h1>
		<p>Самые прибыльные и интересные игры <b>Avocado онлайн</b> представлены на данном официальном сайте.
		</p>
		<p>Лучшие возможности для игры на официальном сайте Avocado лицензионные игры, бонусы и быстрые
			платежные методы для всех игроков.</p>
		<h2>Avocado промокод</h2>
		<p>Играть на нашем сайте Avocado - просто и прибыльно! </p>
		<p>Платежная система выбирается, учитывая интересы региона и персональных желаний потенциальных
			клиентов. Главными критериями отбора являются удобство и безопасность. Главным достоинством
			большинства казино является наличие большого количества платежных систем, что позволяет каждому
			посетителю выбрать способ оплаты, наиболее удобный для него.</p>
		<p>Играть онлайн пользователь может без депозита своих средств в игру <b>Avocado</b> онлайн это
			значит, что бонусы не требуют обязательного пополнения счета. Мы гарантируем честную игру,
			большие промокоды и быстрый вывод средств. Участвуйте в чемпионатах и лотереях, забирайте
			промокоды за активную игру. Все онлайн игры предоставлены на нашем официальном сайте без
			изменения функционала, каждую игру проверяйте на честность.</p>
		<h3>Мобильная версия</h3>
		<p>Тут уже готово все: лицензия, домен, технической обеспечение, контент, платежные системы и так
			далее. Это требует минимальных затрат в плане времени и финансов, что является несомненным
			плюсом. Однако заказчик в этом случае не сможет самостоятельно принимать все решения, касающиеся
			казино. И тут уже каждый сам выбирает что ему важнее: минимальные затраты или возможность
			самостоятельно принимать решения.</p>
		<p>Компания предлагает качественную техническую поддержку. Бесперебойная система, работающая
			ежедневно и круглосуточно, а также компетентные сотрудники понравятся игрокам. Каждый клиент
			может задать службе поддержки любой интересующий его вопрос и получить на него ответ.</p>
		<h4>Avocado бонус</h4>
		<p>Суммы призов также варьируются – от небольших утешительных призов, до действительно солидных
			денежных вознаграждений. Всё зависит только от удачи, от того, насколько она благосклонна
			сегодня к конкретному игроку. Вывести свой приз можно в любое время – достаточно заглянуть в
			личный кабинет и заказать выплату средств.</p>
		<p>Если казино имеет лицензию, то это гарантия законности его деятельности, что является необходимым
			условием для привлечения пользователей. Также оно получает возможность работать с различными
			платежными системами и популярными разработчиками программного обеспечения. Вариант
			лицензирования является оптимальным для региона, в котором проживает заказчик. Клиенту также
			предоставляется консультация по юридическим вопросам, интересующим его.</p>
		<p>
			Компания предоставляет заказчику специальное программное обеспечение, позволяющее осуществлять
			управление финансами, безопасностью и контентом. Также происходит разработка и отладка функций,
			дизайна и так далее. Сделать это самостоятельно было бы гораздо труднее.
		</p>
	</div>
	<main class="layout">
		<div v-if="!isMob" class="layout__aside">
			<HistorySlots class="layout__slots-history"/>
			<Sidebar :page="page"/>
		</div>
		<Loader class="layout__loader" id="loadPage" :loading="$root.isLoading" v-show="$root.isLoading"/>

		<div class="layout__body" v-show="!$root.isLoading" :class="[page == 'x50' ? 'overflow-hidden' : '']">
			<router-view v-slot="{ Component }">
				<transition name="fade" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
		</div>
	</main>

	<SignIn v-if="user === null" />
	<SignUp v-if="user === null" />
	<UserSettings v-if="user !== null" />
	<Deposit v-if="user !== null" />
	<FirstBonus v-if="user !== null && user.bonus_use == 0" />
	<CheckModal />
	<PinModal v-if="user !== null" />

	<div v-if="this.user && this.user.impersonate" class="impersonate">
		<a
			:href="this.user.impersonate"
			class="btn btn--primary impersonate__btn">
			Нажмите сюда, чтобы снова авторизоваться в своём аккаунте
		</a>
	</div>

	<Footer/>

	<Notification/>
</template>

<script>

	import { mapState } from 'pinia'
	import { useUserStore } from '../stores/User'
    import Header from "./Header/Header.vue";
	import Footer from "./Footer/Footer.vue";
    import SignIn from "./Modals/SignIn.vue";
    import SignUp from "./Modals/SignUp.vue";
    import UserSettings from "./Modals/UserSettings.vue";
    import CheckModal from "./Modals/CheckModal.vue";
    import PinModal from "./Modals/Pin.vue";
    import Deposit from "./Modals/Deposit.vue";
    import FirstBonus from "./Modals/FirstBonus.vue";
    import Sidebar from "./Navigation/Sidebar.vue";
    import HistorySlots from "./History/Slots.vue";
    import Notification from "./Notification/Notification.vue";
	import Sprite from "./Sprite.vue";
	import BreakpointsMixin from "../mixins/breakpoints-mixin.vue";
	import Loader from "./blocks/Loader.vue";

	export default {
        components: {
			Sprite,
            Header,
			Footer,
            SignIn,
            SignUp,
            UserSettings,
            CheckModal,
            PinModal,
            Deposit,
            FirstBonus,
            Sidebar,
            HistorySlots,
            Notification,
			Loader
        },
		mixins: [
			BreakpointsMixin
		],
        data() {
            return {

            }
        },
		computed: {
			...mapState(useUserStore, ['user']),

			page() {
				return this.$router.currentRoute.name;
			}
		}
    }
</script>